import classNames from 'classnames';
import type { MouseEventHandler, ReactNode } from 'react';

import { Box } from '../index';
import { buttonIconStyle } from './ButtonIcon.css';

export interface ButtonIconProps {
  id?: string;
  icon: ReactNode;
  label?: string;
  size?: 'regular' | 'large';
  variant?: 'solid' | 'outline';
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({ id, icon, label, size, variant, onClick }) => {
  return (
    <Box
      id={id}
      component="button"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      padding="none"
      aria-label={label}
      data-variant={variant}
      data-size={size}
      className={classNames(buttonIconStyle, variant)}
      onClick={onClick}
    >
      {icon}
    </Box>
  );
};
